var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "no-ssr",
    [
      _c(
        "el-container",
        [
          _c(
            "el-header",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: ![
                    "/tpl/personSet",
                    "/tpl/general",
                    "/tpl/accountInfo",
                    "/tpl/costStatistics",
                    "/tpl/signers",
                    "/tpl/corpSet",
                    "/tpl/Preferences",
                    "/tpl/myAuth"
                  ].includes(_vm.$route.path),
                  expression:
                    "!['/tpl/personSet', '/tpl/general', '/tpl/accountInfo', '/tpl/costStatistics', '/tpl/signers', '/tpl/corpSet', '/tpl/Preferences', '/tpl/myAuth'].includes($route.path)"
                }
              ],
              class: {
                "my-el-header": true,
                homePage: _vm.isInDingTalk
                  ? false
                  : _vm.isHomePage && _vm.isScrollChange && _vm.useThisHeader
              }
            },
            [
              _c(
                "div",
                { staticClass: "header" },
                [
                  _c(
                    "el-row",
                    { attrs: { type: "flex" } },
                    [
                      _c(
                        "el-col",
                        { staticClass: "jzq-logo", attrs: { span: 3 } },
                        [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.isInDingTalk
                                  ? "/viewIndex"
                                  : _vm.globalConfig.domain.junziqanIndex
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: "/images/logo/jzq-logo.png",
                                  alt: ""
                                }
                              })
                            ]
                          )
                        ]
                      ),
                      _c(
                        "el-col",
                        {
                          style: {
                            display:
                              _vm.isInDingTalk &&
                              _vm.$route.path === "/auth/authGuide"
                                ? "none"
                                : "block"
                          },
                          attrs: { span: 15 }
                        },
                        [
                          _c(
                            "nav",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showMenu,
                                  expression: "showMenu"
                                }
                              ]
                            },
                            [
                              _vm.currentAuthUser.userType == 0 ||
                              _vm.currentAuthUser.userType == 1
                                ? _c("ul", [
                                    _c(
                                      "li",
                                      {
                                        class:
                                          _vm.$route.path.indexOf(
                                            "viewIndex"
                                          ) !== -1
                                            ? "active"
                                            : ""
                                      },
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            staticClass: "item",
                                            attrs: { to: "/viewIndex" }
                                          },
                                          [_vm._v("首页")]
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "li",
                                      {
                                        class:
                                          _vm.$route.path.indexOf(
                                            "signInfo"
                                          ) !== -1 &&
                                          ![
                                            "/signInfo/entAccess",
                                            "/signInfo/viewDealTypeList"
                                          ].includes(_vm.$route.path)
                                            ? "active"
                                            : ""
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "item",
                                            on: {
                                              click: function($event) {
                                                return _vm.turnFilePage({
                                                  path: "/signInfo/signList",
                                                  query: { signStatus: 2 }
                                                })
                                              }
                                            }
                                          },
                                          [_vm._v("文件管理")]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "li",
                                      {
                                        class:
                                          _vm.$route.path.indexOf(
                                            "judicialService"
                                          ) !== -1
                                            ? "active"
                                            : "",
                                        staticStyle: { cursor: "pointer" },
                                        on: { click: _vm.pageChangeFn }
                                      },
                                      [
                                        _c("div", { staticClass: "item" }, [
                                          _vm._v("司法服务")
                                        ])
                                      ]
                                    ),
                                    _vm.$store.getters.currentAuthUser
                                      .userType === 1
                                      ? _c(
                                          "li",
                                          {
                                            class: [
                                              "/signInfo/viewDealTypeList",
                                              "/signInfo/entAccess"
                                            ].includes(_vm.$route.path)
                                              ? "active"
                                              : "",
                                            staticStyle: { cursor: "pointer" },
                                            on: { click: _vm.APIabutment }
                                          },
                                          [
                                            _c("div", { staticClass: "item" }, [
                                              _vm._v("API对接")
                                            ])
                                          ]
                                        )
                                      : _vm._e(),
                                    !_vm.isInDingTalk &&
                                    (_vm.accountInfoVO.userType === 1 ||
                                      _vm.bindCorpUsersList.length === 1)
                                      ? _c(
                                          "li",
                                          {
                                            class: _vm.isSmart ? "active" : ""
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "item",
                                                on: {
                                                  click: _vm.ywtIntroductionFn
                                                }
                                              },
                                              [_vm._v("业务定制系统")]
                                            )
                                          ]
                                        )
                                      : !_vm.isInDingTalk &&
                                        _vm.bindCorpUsersList.length > 1
                                      ? _c(
                                          "li",
                                          {
                                            class: _vm.isSmart ? "active" : ""
                                          },
                                          [
                                            _c(
                                              "el-dropdown",
                                              {
                                                on: {
                                                  command: _vm.handleCommandFn
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "el-dropdown-link item"
                                                  },
                                                  [_vm._v("业务定制系统")]
                                                ),
                                                _c(
                                                  "el-dropdown-menu",
                                                  {
                                                    attrs: { slot: "dropdown" },
                                                    slot: "dropdown"
                                                  },
                                                  _vm._l(
                                                    _vm.bindCorpUsersList,
                                                    function(item, index) {
                                                      return _c(
                                                        "el-dropdown-item",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value:
                                                                item.userStemFrom !==
                                                                -16,
                                                              expression:
                                                                "item.userStemFrom !== -16"
                                                            }
                                                          ],
                                                          key: index,
                                                          attrs: {
                                                            command: item
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.corpName
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ])
                                : _vm.currentAuthUser.superFlag == 0 ||
                                  _vm.currentAuthUser.superFlag == 1
                                ? _c("ul", [
                                    _c(
                                      "li",
                                      {
                                        class:
                                          _vm.$route.path.indexOf(
                                            "viewIndex"
                                          ) !== -1
                                            ? "active"
                                            : ""
                                      },
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            staticClass: "item",
                                            attrs: { to: "/viewIndex" }
                                          },
                                          [_vm._v("首页")]
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "li",
                                      {
                                        class:
                                          _vm.$route.path.indexOf(
                                            "signInfo"
                                          ) !== -1
                                            ? "active"
                                            : ""
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "item",
                                            on: {
                                              click: function($event) {
                                                return _vm.turnFilePage({
                                                  path:
                                                    "/corp/signInfo/signList",
                                                  query: { signStatus: 4 }
                                                })
                                              }
                                            }
                                          },
                                          [_vm._v("文件管理")]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "li",
                                      {
                                        class:
                                          _vm.$route.path.indexOf(
                                            "judicialService"
                                          ) !== -1
                                            ? "active"
                                            : "",
                                        staticStyle: { cursor: "pointer" },
                                        on: { click: _vm.pageChangeFn }
                                      },
                                      [
                                        _c("div", { staticClass: "item" }, [
                                          _vm._v("司法服务")
                                        ])
                                      ]
                                    ),
                                    !_vm.isInDingTalk &&
                                    (_vm.accountInfoVO.userType === 1 ||
                                      _vm.bindCorpUsersList.length === 1)
                                      ? _c(
                                          "li",
                                          {
                                            class: _vm.isSmart ? "active" : ""
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "item",
                                                on: {
                                                  click: _vm.ywtIntroductionFn
                                                }
                                              },
                                              [_vm._v("业务定制系统")]
                                            )
                                          ]
                                        )
                                      : !_vm.isInDingTalk &&
                                        _vm.bindCorpUsersList.length > 1
                                      ? _c(
                                          "li",
                                          {
                                            class: _vm.isSmart ? "active" : ""
                                          },
                                          [
                                            _c(
                                              "el-dropdown",
                                              {
                                                on: {
                                                  command: _vm.handleCommandFn
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "el-dropdown-link item"
                                                  },
                                                  [_vm._v("业务定制系统")]
                                                ),
                                                _c(
                                                  "el-dropdown-menu",
                                                  {
                                                    attrs: { slot: "dropdown" },
                                                    slot: "dropdown"
                                                  },
                                                  _vm._l(
                                                    _vm.bindCorpUsersList,
                                                    function(item, index) {
                                                      return _c(
                                                        "el-dropdown-item",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value:
                                                                item.userStemFrom !==
                                                                -16,
                                                              expression:
                                                                "item.userStemFrom !== -16"
                                                            }
                                                          ],
                                                          key: index,
                                                          attrs: {
                                                            command: item
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.corpName
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ])
                                : _vm._e()
                            ]
                          )
                        ]
                      ),
                      _c(
                        "el-col",
                        {
                          staticStyle: {
                            "padding-left": "20px",
                            "box-sizing": "border-box"
                          },
                          attrs: { span: 6 }
                        },
                        [
                          !_vm.isInDingTalk
                            ? _c(
                                "el-row",
                                [
                                  _c("user-header", {
                                    staticStyle: { float: "right" }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _c("userConsoleHeader"),
          _c("div", {
            staticClass: "y-header",
            staticStyle: { height: "60px" }
          }),
          _c(
            "el-dialog",
            {
              staticClass: "dialog",
              attrs: {
                title: "添加集团账户电子签署系统",
                visible: _vm.createCorpShow,
                "close-on-click-modal": false,
                width: "30%"
              },
              on: {
                "update:visible": function($event) {
                  _vm.createCorpShow = $event
                }
              }
            },
            [
              _c(
                "el-form",
                { ref: "createCorpForm", attrs: { model: _vm.createCorpInfo } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "集团名称" } },
                    [
                      _c("el-input", {
                        attrs: {
                          autocomplete: "off",
                          placeholder: "50字以内，可不填",
                          maxlength: "50",
                          clearable: true
                        },
                        model: {
                          value: _vm.createCorpInfo.name,
                          callback: function($$v) {
                            _vm.$set(_vm.createCorpInfo, "name", $$v)
                          },
                          expression: "createCorpInfo.name"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.createCorpShow = false
                        }
                      }
                    },
                    [_vm._v("取 消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleCreateCorp }
                    },
                    [_vm._v("确 定")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              staticClass: "dialog",
              attrs: {
                title: "提示",
                visible: _vm.apiOpenShow,
                "close-on-click-modal": false,
                width: "30%"
              },
              on: {
                "update:visible": function($event) {
                  _vm.apiOpenShow = $event
                }
              }
            },
            [
              _c("p", [_vm._v("未开通君子签API服务，是否开通？")]),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini" },
                      on: {
                        click: function($event) {
                          _vm.apiOpenShow = false
                        }
                      }
                    },
                    [_vm._v("暂不开通")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "mini",
                        loading: _vm.apiOpening
                      },
                      on: { click: _vm.handleOpenMerchant }
                    },
                    [_vm._v("立即开通")]
                  )
                ],
                1
              )
            ]
          ),
          _vm.isRouterAlive ? _c("el-main", [_c("nuxt")], 1) : _vm._e(),
          _c("suspend", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showMenu,
                expression: "showMenu"
              }
            ]
          }),
          _vm.$route.path === "/viewIndex" && !_vm.isInDingTalk
            ? _c("contacts", {
                ref: "contact",
                on: { showCorpAds: _vm.gotoEnd }
              })
            : _vm._e(),
          _c("my-footer", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showMenu,
                expression: "showMenu"
              }
            ]
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-314f53c6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-314f53c6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./layouts/default.vue
// module id = R7nB
// module chunks = 2 3 6 8 15 16 18 19 20 21 22 25 37